var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-2"},[_vm._v("\n    "+_vm._s(_vm.display)+"\n  ")]),_vm._v(" "),_c('vue-slider',{attrs:{"min":_vm.min,"max":_vm.max,"interval":_vm.interval,"enable-cross":false},on:{"drag-end":_vm.change},model:{value:(_vm.tValue),callback:function ($$v) {_vm.tValue=$$v},expression:"tValue"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e06200","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fields/SliderRange.vue
// module id = null
// module chunks = 